export default function WaterSewerDetails() {
    return (
      <div>
        <div className="mma-bg bg-image">

        <div className="gap-spacer"></div>
		<div className="page-title top-cap-outlines">
			<h2>Water &amp; Sewer</h2>
		</div>

		{/*End Large Image Space*/}
		{/*Start Main Content*/}
		<div className="content-fluid">

			<div className="mb-960-center-container mid-side-outlines">
				{/*Full Width Element*/}
				<div className="mb-960-col-50p">
					<div className="left-right-padding-1em">
						<h4>Billing</h4>
						<p> Water and sewer bills are mailed out quarterly. Checks are made payable to MMA (Morrisville Municipal Authority). The MMA also does maintenance on water mains and related infrastructure (street valves, hydrants, laterals between mains and curb stops, etc.).  Some parts of the system are over 100 years old (not just in Morrisville – many areas in the Northeastern U.S.).
						</p>
						<p>
							Rather than raise rates for the customers that have lower usage, we reduced the water charge for those using less than 5,000 gallons per quarter and have put in place a uniform metering charge for all users. If you have other questions about your water or sewer service, contact the Morrisville Municipal Authority (MMA) at Borough Hall.
						</p>
						
				</div>
				<div className="left-right-padding-1em">
						<h4>Property Sale Requirements</h4>
						<p> The Morrisville Municipal Authority (MMA) requires the replacement of any galvanized water service line, and a sewer lateral inspection must be completed before the sale of your property.</p>
						<p>For more information please visit their website: <a href="http://www.mmawatersewer.org/">http://www.mmawatersewer.org/&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a> or contact them at (215)295-8181 option #2.
						</p>
				</div>
				</div>

				<div className="mb-960-col-50p">
					<div className="left-right-padding-1em">
						<h4>MMA Website</h4>
						<p>
							All Morrisville Municipal Authority (MMA) information can be found on their website:<br/> <a href="http://www.mmawatersewer.org/">http://www.mmawatersewer.org/&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a>
						</p>
						</div>






				</div>
			</div>


		</div>
		<div className="page-footer bottom-cap-outlines">&nbsp;</div>
		
 
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>













        </div>
      </div>
    )
}
